/* ─────────────────────────────────────────────────────────────
 * MindTime Constants
 * Route paths, navigation items, and shared enums
 * ───────────────────────────────────────────────────────────── */

// Route paths
export const MINDTIME_PATHS = {
  HOME: '/mindtime/home',
  MY_BACKUPS: '/mindtime/my-backups',
  USERS_BACKUPS: '/mindtime/users/backups',
  // EXPLORER: '/mindtime/explorer',
  USERS: '/mindtime/users',
  PRICES: '/mindtime/prices',
  LISTS: '/mindtime/lists',
  HISTORY: '/mindtime/history',
  SUPPORT: '/mindtime/support',
  SUPPORT_SERVICE_STATUS: '/mindtime/support/service-status',
  SUPPORT_DOWNLOADS: '/mindtime/support/downloads',
  BACKUP_PORTAL: '/mindtime/backup-portal',
  SECURITY: '/mindtime/security',
  SECURITY_SOC: '/mindtime/security/soc',
  SECURITY_DASHBOARD: '/mindtime/security/soc',
  SECURITY_CLIENTS: '/mindtime/security/edr/clients',
  SECURITY_ENDPOINTS: '/mindtime/security/edr/endpoints',
} as const;

// Security category segments (used to build nested Security route paths)
export const SECURITY_SEGMENTS = {
  SOC: 'soc',
  EDR: 'edr',
  XDR: 'xdr',
  SIEM: 'siem',
  AGENTS: 'agents-management',
} as const;

export const SERVER_STATUS_API_URL =
  'https://mindtime.eu/wp-json/serverstatus/v1/data';

// Navigation items (used by MindtimeSidebar)
export const MINDTIME_NAV_ITEMS = [
  { key: 'home', label: 'Home', path: MINDTIME_PATHS.HOME },
  { key: 'myBackups', label: 'My Backups', path: MINDTIME_PATHS.MY_BACKUPS },
  // { key: 'explorer', label: 'Explorer', path: MINDTIME_PATHS.EXPLORER },
  { key: 'users', label: 'Users', path: MINDTIME_PATHS.USERS },
  { key: 'prices', label: 'Prices', path: MINDTIME_PATHS.PRICES },
  { key: 'lists', label: 'Lists', path: MINDTIME_PATHS.LISTS },
  { key: 'history', label: 'History', path: MINDTIME_PATHS.HISTORY },
  { key: 'support', label: 'Support', path: MINDTIME_PATHS.SUPPORT },
  { key: 'backupPortal', label: 'Backup Portal', path: MINDTIME_PATHS.BACKUP_PORTAL },
] as const;

// Backup user status options
export const BACKUP_USER_STATUSES = ['active', 'disabled', 'error'] as const;

// Price book categories
export const PRICE_CATEGORIES = ['Pro Backup', 'PC Backup', 'VM Backup'] as const;

// Support sidebar sub-modules (order matches main Support nav)
export const SUPPORT_NAV_ITEMS = [
  'Knowledge Base',
  'Service Status',
  'Downloads',
] as const;

// History tabs
export const HISTORY_TABS = ['Users', 'Accounts', 'My Account'] as const;

// User list tabs
export const USER_TABS = ['All', 'Client Users without errors', 'Client Users with errors'] as const;

// Ticket priorities
export const TICKET_PRIORITIES = ['low', 'medium', 'high', 'critical'] as const;
